<script setup lang="ts">
    import { ref, computed } from 'vue'

    import { ScoringSurveyEmailSenderViewModel } from '@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender'

    /* ---------------- props / emits ---------------- */

    const props = defineProps<{
        viewModel: ScoringSurveyEmailSenderViewModel
    }>()

    const emit = defineEmits<{
        (e: 'send-email', subject: string, body: string): void
    }>()

    /* ---------------- shortcuts ---------------- */

    const vm = computed(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    /* ---------------- local state ---------------- */

    const EmailSubject = ref<string>('Please complete this survey')
    const EmailBody = ref<string>('Please click on the following link to complete your survey: {url}')

    /* ---------------- derived ---------------- */

    const numberOfEmailRecipients = computed(
        () => vm.value.projectUserIds.length
    )

    const emailBodyError = computed<string | null>(() =>
        EmailBody.value.indexOf('{url}') === -1
            ? '{url} is required in the message.'
            : null
    )

    const hasErrors = computed(() => emailBodyError.value != null)

    /* ---------------- actions ---------------- */

    function handleSendEmail()
    {
        emit('send-email', EmailSubject.value, EmailBody.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send email ({{numberOfEmailRecipients}})</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="scoring-survey-email-sender-form" @submit.prevent="handleSendEmail">
                            <div class="form-group">
                                <label>Subject:</label>
                                <input type="text" class="form-control" v-model.trim="EmailSubject" required>
                                <div class="error">{{emailSubjectError}}</div>
                            </div>
                            <div class="form-group">
                                <textarea rows="5" class="form-control" v-model.trim="EmailBody" required></textarea>
                                <div class="error">{{emailBodyError}}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        <button type="submit" form="scoring-survey-email-sender-form" :disabled="hasErrors" class="btn btn-primary">Send email</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>